import { Typography, Avatar, Button } from '@mui/material';
import React, { Component, useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from "react-router-dom";
import useStyles from '../styles';
import { useDispatch } from 'react-redux';


const Footer = () => {

    const location = useLocation();
    const classes = useStyles();
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const history = useHistory();

    const dispatch = useDispatch();

    const logout = () => {
        dispatch({ type: 'LOGOUT' })
        history.push('/');
        setUser(null);
    }

    const isSignup = false;

    useEffect(() => {
        const token = user?.token;
        //jwt goes here
        setUser(JSON.parse(localStorage.getItem('profile')));
    }, [location]);

    return (
        <footer className={classes.footer}>
            {user?.result ? (
                <Link to="/" variant="contained" color="primary" onClick={logout}>Logout</Link>
            ) : (
                <Link to="/auth" variant="contained" color="primary">Admin</Link>
            )}
        </footer>
    )

}

export default Footer;